// src/constants/volunteerAvailabilityDays.ts
export type VolunteerAvailabilityDayOption = {
  value: string;
  label: string;
};

export const volunteerAvailabilityDays: VolunteerAvailabilityDayOption[] = [
  { value: "mon_jul_14", label: "Mon Jul 13" },
  { value: "tue_jul_15", label: "Tue Jul 14" },
  { value: "wed_jul_16", label: "Wed Jul 15" },
  { value: "thu_jul_17", label: "Thu Jul 16" },
  { value: "fri_jul_17", label: "Fri Jul 17" },
];

export function getVolunteerAvailabilityDayOptions() {
  return volunteerAvailabilityDays;
}